export const findQuotes = (
  body: string | null | undefined,
): { message: string | null; quotes: string | null } => {
  let message = body ?? null;
  let quotes = null;

  try {
    // A `<div>` in an inert document (no browsing context: nothing loads,
    // nothing runs) rather than one created by the live page, whose
    // `innerHTML` fetches the images it is given even while detached, so an
    // `<img src=x onerror=…>` in an inbound email fired in the CRM during this
    // split, before the sanitizer saw it. Still a div (fragment parsing, the
    // same tree as before) rather than DOMParser's full-document parse, which
    // would move a leading `<style>` or `<title>` into a head and drop it.
    const dom = document.implementation
      .createHTMLDocument('')
      .createElement('div');
    dom.innerHTML = body ?? '';
    const isQuotes = (node: ChildNode): node is Element =>
      node instanceof Element && node.tagName === 'BLOCKQUOTE';
    const isEmptyTag = (node: ChildNode) =>
      (node instanceof Element && node.tagName === 'BR') || node.nodeType !== 1;
    let quoteFound: any = null;
    let quoteFoundIndex: number | null = null;

    dom.childNodes.forEach((node, index) => {
      if (isQuotes(node)) {
        quoteFound = node;
        quoteFoundIndex = index;
        return;
      }

      node.childNodes.forEach(child => {
        if (isQuotes(child)) {
          quoteFound = child.parentNode;
          quoteFoundIndex = index;
        }
      });
    });

    quoteFoundIndex = quoteFoundIndex ?? 0;

    if (quoteFound instanceof Element) {
      const quoteNode = quoteFound;
      let isLastNotEmpty = true;
      for (
        let index = quoteFoundIndex + 1;
        index < dom.childNodes.length;
        index += 1
      ) {
        if (!isEmptyTag(dom.childNodes[index])) {
          isLastNotEmpty = false;
        }
      }
      if (isLastNotEmpty) {
        // The trailing nodes go behind the toggle with the quote (a bare
        // text node such as a mobile signature counts as "empty" above but
        // is still content), serialized through a holder so text is escaped.
        const holder = dom.ownerDocument.createElement('div');
        for (
          let index = quoteFoundIndex + 1;
          index < dom.childNodes.length;
          index += 1
        ) {
          holder.appendChild(dom.childNodes[index].cloneNode(true));
        }
        quotes = quoteNode.outerHTML + holder.innerHTML;
        // Walked from the end: childNodes is live, so removing while counting
        // up skipped every other trailing node.
        for (
          let index = dom.childNodes.length - 1;
          index > quoteFoundIndex;
          index -= 1
        ) {
          dom.removeChild(dom.childNodes[index]);
        }
        quoteNode.parentNode?.removeChild(quoteNode);
        message = dom.innerHTML;
      }
    }
  } catch (error) {
    console.error('Email parse error', error);
  }

  return { message, quotes };
};
